<div class="searcher">
  <div class="typo-h2 title">{{ "appointmentSelection.selectPatient" | transloco }}</div>
  <div class="search-row">
    <mat-form-field class="grow" subscriptSizing="dynamic">
      <mat-label>{{ 'form.label.patient' | transloco }}</mat-label>
      <input (blur)="restoreSelection()" [formControl]="patientCtrl" [matAutocomplete]="patientAutocomplete"
             [placeholder]="'form.placeholder.search' | transloco" matInput>

      <!-- matSuffix has to sit on an element that is always there: a node inside a @if is
           projected as the block, not as its content, and would land next to the input. -->
      <div class="searching" matSuffix>
        @if (searching()) {
          <mat-spinner diameter="20"/>
        }
      </div>

      <mat-autocomplete #patientAutocomplete (closed)="restoreSelection()" (optionSelected)="patientSelected($event)"
                        [displayWith]="displayPatient">
        @for (patientDto of filteredPatients(); track patientDto.patientId) {
          <mat-option [value]="patientDto">
            <div>{{ patientDto.firstName }} {{ patientDto.lastName }}</div>
            <div class="small-text">{{ patientDto.dateOfBirth }}</div>
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>

    <app-icon-button (click)="addPatient()" colorVariant="primary" icon="add" size="big"/>
  </div>
</div>
